<section class="section dashboard">
  <div class="row">
    <div class="col-xxl-3 col-xl-6">
      <div class="card info-card revenue-card">
        <div class="card-body">
          <h5 class="card-title">Active patients</h5>

          <div class="d-flex align-items-center mt-1">
            <div class="ps-0">
              <div class="d-flex gap-2 align-items-center">
                <h6>{{ AppointmentsStatus.activePatients.total }}</h6>
                <span class="text-body-tertiary">/ Today</span>
              </div>
              <div class="d-flex align-items-end">
                <span class="text-success small me-1 fw-bold">{{ AppointmentsStatus.activePatients.dischargeToday }}</span>
                <span class="text-muted small">Discharge today</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xxl-3 col-xl-6">
      <div class="card info-card sales-card">
        <div class="card-body">
          <h5 class="card-title">Internal Medicine</h5>

          <div class="d-flex align-items-center">
            <div class="ps-0">
              <div class="d-flex gap-2 align-items-center">
                <h6>{{ AppointmentsStatus.internalMedicine.total }}</h6>
                <span class="text-body-tertiary">/ Today</span>
              </div>
              <div class="d-flex align-items-end">
                <span class="text-success small me-1 fw-bold">{{ AppointmentsStatus.internalMedicine.complete }}</span>
                <span class="text-muted small">Complete</span>
                <span class="mx-2">|</span>
                <span class="text-warning small me-1 fw-bold">{{ AppointmentsStatus.internalMedicine.pending }}</span>
                <span class="text-muted small">Pending</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xxl-3 col-xl-6">
      <div class="card info-card customers-card">
        <div class="card-body">
          <h5 class="card-title">Orthopedist appointments</h5>

          <div class="d-flex align-items-center">
            <div class="ps-0">
              <div class="d-flex gap-2 align-items-center">
                <h6>{{ AppointmentsStatus.orthopedist.total }}</h6>
                <span class="text-body-tertiary">/ Today</span>
              </div>
              <div class="d-flex align-items-end">
                <span class="text-success small me-1 fw-bold">{{ AppointmentsStatus.orthopedist.complete }}</span>
                <span class="text-muted small">Complete</span>
                <span class="mx-2">|</span>
                <span class="text-warning small me-1 fw-bold">{{ AppointmentsStatus.orthopedist.pending }}</span>
                <span class="text-muted small">Pending</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xxl-3 col-xl-6">
      <div class="card info-card customers-card">
        <div class="card-body">
          <h5 class="card-title">Neurologist appointments</h5>

          <div class="d-flex align-items-center">
            <div class="ps-0">
              <div class="d-flex gap-2 align-items-center">
                <h6>{{ AppointmentsStatus.neurologist.total }}</h6>
                <span class="text-body-tertiary">/ Today</span>
              </div>
              <div class="d-flex align-items-end">
                <span class="text-success small me-1 fw-bold">{{ AppointmentsStatus.neurologist.complete }}</span>
                <span class="text-muted small">Complete</span>
                <span class="mx-2">|</span>
                <span class="text-warning small me-1 fw-bold">{{ AppointmentsStatus.neurologist.pending }}</span>
                <span class="text-muted small">Pending</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Recent Sales -->
    <div class="col-12">
      <app-calender-view (OnEventClick)="CheckAppt($event)" (SelectedMonth)="GetSelectedMonth($event)" [CalenderEvents]="CalenderEventes"></app-calender-view>
    </div>
    <!-- End Recent Sales -->
  </div>
</section>
